import React, { useState, useEffect, Suspense } from 'react'
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios'
import TagsInput from 'react-tagsinput'
import { ReactSession } from 'react-client-session';

import Header from '../../Header/Header';
import Sidebar from '../../Sidebar/Sidebar';
import Loader from '../../Global/Loader';

import styles from '../../../App.module.css';
import classes from './AddImage.module.css'
import Tabs from '../Tabs/Tabs';

const noThumb = "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Image_not_available.png/640px-Image_not_available.png";

function AddImage() {
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [title, setTitle] = useState('');
    const [tags, setTags] = useState([]);
    const [categories, setCategories] = useState([]);
    const [image, setImage] = useState(null);
    const [thumb, setThumb] = useState('');
    const [ifDisabled, setIfDisabled] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState({
        status: false,
        message: ''
    });
    ReactSession.setStoreType("localStorage");

    const logged_user = ReactSession.get("logged_user");

    useEffect(() => {
        !logged_user && navigate('/login');
    } , [])

    useEffect(() => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/categories.php`, {
            type: 2
        }, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        }).then(res => {
            setCategories(res.data);
        }).catch(err => {
            console.log(err);
        })
    } , [])

    useEffect(() => {
        image && setTitle(image.name);
    }, [image])

    const handleChangeTitle = (e) => {
        setTitle(e.target.value);
    }

    const onSubmit = (e) => {
        setIfDisabled(true);

        var data = new FormData();
        data.append('user_id', logged_user);
        data.append('pic-title', title);
        data.append('pic-desc', e.description);
        data.append('tags', tags.toString());
        data.append('categ', e.categ);
        data.append('play-img', image);
        data.append('priv', e.priv);
        data.append('nsfw', e.nsfw);

        axios.post(`${process.env.REACT_APP_API_URL}/api/user/add-image.php`, data, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        }).then(res => {
            // console.log(res.data);
            setIsSubmitted({
                status: true,
                type: res.data.status,
                message: res.data.message
            });

            setIfDisabled(false);
        }).catch(err => {
            console.log(err);
        })
    }

    const onImageChange = (e) => {
        setImage(e.target.files[0]);

        let reader = new FileReader();
        reader.onload = (e) => {
            setThumb(e.target.result);
        };
        
        if(e.target.files[0]){
            reader.readAsDataURL(e.target.files[0]);
        }else {
            setThumb('');
        }
    }

    const handleChangeTags = (tags) => {
        setTags(tags);
    }

    return (
        <>
            <Header />
            <div className={styles.main_body}>
            <Suspense fallback="<div>Please wait...</div>">
                <Sidebar />
            </Suspense>
            <Suspense fallback="<div>Please wait...</div>">
                <div className={styles.main_content + ` main-content`}>
                    <div className={classes.video_component + ` p-4`}>
                        <Tabs active="addimage" />
                        <div className={classes.panel}>
                            <div className={classes.panel_body}>
                                {
                                    !isSubmitted.status ? <div className="row">
                                        <div className="col-8">
                                            <form onSubmit={handleSubmit(onSubmit)}>
                                                <div className="form-group">
                                                    <label>Choose the Image: (500px X 350px)</label>
                                                    <input {...register('play_img', {required: true})} onChange={onImageChange}  className="form-control" type="file" accept="image/*" />
                                                    {errors.play_img && <p className={styles.error_msg}>Please upload an image</p>}
                                                </div>
                                                <div className="form-group">
                                                    <label>Title:</label>
                                                    <input {...register('title', {required: true})} value={title} onChange={handleChangeTitle}  className="form-control" type="text" placeholder="" />
                                                    {errors.title && <p className={styles.error_msg}>This field cannot be empty</p>}
                                                </div>
                                                <div className="form-group">
                                                    <label>Category:</label>
                                                    <select {...register('categ')} className="form-control">
                                                        <optgroup label="Categories" dangerouslySetInnerHTML={{__html: `${categories}`}} />
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label>Description:</label>
                                                    <textarea {...register('description')} className="form-control" rows="3" placeholder=""></textarea>
                                                </div>
                                                <div className="form-group">
                                                    <label>Tags:</label>
                                                    <TagsInput value={tags} onChange={handleChangeTags} />
                                                </div>
                                                <div className="form-group">
                                                    <label>NSFW:</label>
                                                    <div className={`form-group ${classes.radio}`}>
                                                        <label className="radio inline">
                                                            <input {...register('nsfw')} type="radio" className="styled" value="1" />Not safe
                                                        </label>
                                                        <label className="radio inline">
                                                            <input {...register('nsfw')} type="radio" className="styled" value="0" defaultChecked={true} />Safe
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label>Privacy:</label>
                                                    <div className={`form-group ${classes.radio}`}>
                                                        <label className="radio inline">
                                                            <input {...register('priv')} type="radio" className="styled" value="1"  />Private
                                                        </label>
                                                        <label className="radio inline">
                                                            <input {...register('priv')} type="radio" className="styled" value="0" defaultChecked={true} />Public
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className={`form-group mb-0 ${styles.btn_flex}`}>
                                                    <button className="btn btn-primary" type="submit" disabled={ifDisabled}>{ifDisabled ? 'Uploading' : 'Upload'}</button>
                                                    {
                                                        ifDisabled && <Loader />
                                                    }
                                                </div>
                                            </form>
                                        </div>
                                        <div className="col-4">
                                            <div className={`${classes.image} mt-4 mb-3`}>
                                                <label htmlFor="">Image:</label>
                                                <img width="100%" src={thumb} onError={e => {e.target.src = noThumb}} alt="thumb" />
                                            </div>
                                        </div>
                                    </div>
                                    : <div className='mt-4'>
                                        <div className={`alert alert-${isSubmitted.type}`} role="alert">{isSubmitted.message}</div>
                                        {
                                            isSubmitted.type === 'success' && <div className="align-center" align="center">
                                                <Link to="/dashboard/images" className="btn btn-primary">Manage media.</Link>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Suspense>
            </div>
        </>
    )
}

export default AddImage